import { CustomerChoices } from "./customer-choices.model";
import { ProductDetailsModel } from "./product-details.model";
import { UploadDetailsModel } from "./upload-details.model";

export class ClientSessionStateModel {
  sessionKey: string = "";
  authSessionData: any = {};
  categoryCode = "";
  subcategoryCode = "";
  uploadDesign = false;
  targetService = "";
  productDetails: ProductDetailsModel = {};
  uploadDetails: UploadDetailsModel = {};
  quantity: number = 0;
  container = "";
  outsideFileName = "";
  insideFileName = "";
  optionSpecs: CustomerChoices | undefined = undefined;
  isEdit = false;
  IsReorder = false;
  referer = "";
  continuedProject: any;
  reviewBack: boolean = false;
}
